/* eslint react-hooks/set-state-in-effect: ["warn"] */
import { useEffect, useState } from "react";
import { useStoreId } from "../../core/auth/useLoggedInUser";
import { fetchAPI, TASKS_SERVICE_URL } from "../API/tasks.service.helper";

/**
 * Returns sales AND SGF locations for a single product, including sub products when `type` == SPR.
 * Uses MFS, and sometimes not all locations are returned.
 * @param {String} short_id
 * @param {String} type
 */
export function useMFSLocations(short_id: string, type: string) {
  const storeId = useStoreId();

  const full_id = `${type}${short_id}`;
  const [groupedLocationsFromService, setGroupedLocationsFromService] =
    useState({
      data: [] as string[],
      loading: true,
    });

  useEffect(() => {
    if (full_id && storeId) {
      const fetchGroupedLocations = async () => {
        try {
          const url = `${TASKS_SERVICE_URL}/v1/locations/grouped_locations?full_id=${full_id}`;
          const { result } = await fetchAPI("GET", url);
          setGroupedLocationsFromService({ data: [result], loading: false });
        } catch (error) {
          console.error("Error fetching grouped locations:", error);
          setGroupedLocationsFromService({ data: [], loading: false });
        }
      };

      fetchGroupedLocations();
    } else {
      setGroupedLocationsFromService({ data: [], loading: false });
    }
  }, [full_id, storeId]);

  return groupedLocationsFromService;
}
